import { LayoutDimensions } from '@bonanza-social/toolkit/state';

export const getMiddleX = (dimensions: LayoutDimensions) =>
  dimensions.x + dimensions.width / 2;
